<template>
  <main class="workshops">
    <div ref="hero">
      <Info class="u-hidden--from-ipadP" :allways="true"/>
      <AppTitle
        class="c-title--light"
        :data="{ content: pageData.hero.title }"
        :isAnimated="false"
        data-item="title"
      />
      <AppLine data-item="line" :isAnimated="false"/>
      <AppTitle
        class="c-title--dark"
        :data="{ content: pageData.hero.subtitle }"
        :autoPlay="true"
        :isAnimated="false"
        data-item="title"
        type="tube"
      />
      <AppLine data-item="line" :isAnimated="false"/>
    </div>

    <section class="speakers__grid-cont">
      <transition @enter="enter">
        <div class="workshops__grid" v-if="pageData.workshops">
          <AppCard
            v-for="(workshop, key) in pageData.workshops"
            :key="key"
            :title="workshop.workshopTitle"
            :description="workshop.workshopInfo"
            :alt="workshop.hostName"
            :image="workshop.hostPicture"
            :actionLabel="'Discover Workshop'"
            :actionUrl="`/${$route.params.city}/workshops/${workshop.path}`"
            data-lazyanimation="picture"
          />
        </div>
      </transition>
    </section>

    <AppShowcase type="venues" />

    <AppSponsor />

    <AppFooter />
  </main>
</template>

<script>
import { mapGetters } from 'vuex';

import AppLine from '@/components/AppLine.vue';
import AppCard from '@/components/AppCard.vue';
import AppTitle from '@/components/AppTitle.vue';
import AppShowcase from '@/components/AppShowcase.vue';
import AppSponsor from '@/components/AppSponsor.vue';
import AppFooter from '@/components/AppFooter.vue';
import Info from '@/components/Info.vue';

import medusa from '@/scripts/medusa';
import { initials, animations } from '@/scripts/fx';

import content from '@/assets/data/contents/workshops.json';

export default {
  name: 'Workshops',
  components: {
    AppLine,
    AppTitle,
    AppCard,
    AppShowcase,
    AppSponsor,
    AppFooter,
    Info,
  },
  data() {
    return {
      content,
    };
  },
  computed: {
    ...mapGetters(['workshops']),
    pageData() {
      return this.content[this.$route.params.city];
    },
  },
  mounted() {
    this.enterAnimation();
    medusa.recalculateTargets(this.$el);
  },
  methods: {
    enter(el, done) {
      const items = [...el.querySelectorAll('[data-lazyanimation]')];
      items.forEach(item => initials.get('picture')(item, 70));
      medusa.ref.pushToTarget('scrollAnimations', items);
      medusa.prevNodes.push(...items);
      done();
    },
    enterAnimation() {
      const titles = [...this.$refs.hero.querySelectorAll('[data-item="title"] h3')];
      const lines = [...this.$refs.hero.querySelectorAll('[data-item="line"]')];
      lines.forEach(line => initials.get('line')(line));
      titles.forEach(title => initials.get('title')(title));

      animations.get('title')(titles[0]);
      animations.get('line')(lines[0], 300);
      animations.get('title')(titles[1], 400);
      animations.get('line')(lines[1], 700);
    },
  },
  beforeDestroy() {
    medusa.removePrevTargets();
  },
};
</script>

<style lang="scss" scoped>
.workshops {
  .hero {
    .info {
      position: relative;
      top: unset;
      width: 100%;

      transform: translateY($unit-vh * -2);
      z-index: unset;
    }
  }

  &__grid-cont {
    min-height: 50vh;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: $unit-vw * 12;
    grid-row-gap: $unit-vh * 4;
    padding: $unit-vh 0 0;

    @include mq($until: ipadP) {
      grid-template-columns: repeat(1, 1fr);
    }

    @include mq(ipadL) {
      padding: $unit-vh * 2 $unit-vw * 4 0;
    }
  }

  & ::v-deep .picture {
    @include aspect-ratio(13, 17);
  }
}
</style>
